import React from 'react';
import { Phone, MessageSquare } from 'lucide-react';
export function MobileStickyBar() {
  return <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-brand-blue shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] flex" data-id="element-316">
      <a href="tel:5862033701" className="flex-1 flex items-center justify-center gap-2 py-4 text-white font-body font-semibold border-r border-white/20 active:bg-brand-blue-dark transition-colors" data-id="element-317">
        <Phone size={20} data-id="element-318" />
        <span data-id="element-319">Call Now</span>
      </a>
      <a href="#quote" className="flex-1 flex items-center justify-center gap-2 py-4 text-white font-body font-semibold active:bg-brand-blue-dark transition-colors" data-id="element-320">
        <MessageSquare size={20} data-id="element-321" />
        <span data-id="element-322">Get a Quote</span>
      </a>
    </div>;
}